
import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { ProfessionalMarketplace } from '@/components/marketplace/ProfessionalMarketplace';

const Marketplace = () => {
  return (
    <MainLayout>
      <ProfessionalMarketplace />
    </MainLayout>
  );
};

export default Marketplace;
